import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from './copysource';
import { HttpFileDataset } from 'app/model/dataset/http-file.dataset';
import { IAttribute } from 'app/model/base/annotation';

import { Constants } from 'app/shared/shared-constants';

@Metamodel.model({
    name: 'HttpSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(HttpFileDataset) }
})
export class HttpFileCopySource extends CopySource {
    public static readonly REQUEST_TIMEOUT: IAttribute;
    public static readonly MAXCONCURRENT_CONNECTIONS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'REQUEST_TIMEOUT',
        display: stringResources.ModelName_Request_Timeout,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:01:40';

    @Metamodel.attribute({
        templatable: true,
        association: 'MAXCONCURRENT_CONNECTIONS',
        display: stringResources.ModelName_MaxConcurrentConnections,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public maxConcurrentConnections?: number;
}
